/*
 * @Description: 
 * @version: 
 * @Author: yfw
 * @Date: 2022-11-17 13:17:08
 * @LastEditors: yfw
 * @LastEditTime: 2023-02-09 11:37:14
 */
import axios, { AxiosPromise } from 'axios';
// @ts-ignore
import { createSign } from "@/utils/sign"
import { store } from '@/store/index'
import qs from 'qs';

const appid = 1;
const appkey = "7b69a7f5175afef751543548ccf5dde2";

const axiosInstance = axios.create({
  baseURL: "",
  timeout: 30000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  }
});
// @ts-ignore
axiosInstance.interceptors.request.use(config => {
  return config;
});
// @ts-ignore
axiosInstance.interceptors.response.use(
  res => {
    if (res.status == 200 && res.data.code != 200 && res.data.code != 421) {
      const errcode = res.data.error.code;
      let errmsg = res.data.error.message || '出错了 请联系管理员';
      if (errcode == 'E000000002') {
        // Tips('登录超时', 'error');
        setTimeout(() => {
        //   store.dispatch('userlogin/logout').then(res => {
        //     location.reload()
        //   })
        }, 500)
      } else {
        // Tips(errmsg, 'error');
      }
      // throw Error(errcode)
    }
    return res;
  },
  error => {
    const status = error.response.status;
    if (status == 408 || status == 504) {
    //   Tips('请求超时', 'error');
      let url = window.location.href;
      let data = url.split("/");
      window.location.href = data[0] + "/login";
    } else {
    //   Tips('服务器出错了，请联系管理员', 'error');
    }
    return Promise.reject(error)
  });


export const login = (url = "", params = {}) => {
  const res = configPostParam(url, params);
  return axiosInstance.post(res.url, res.params);
}

// 未登录使用
export const configPostParam = (url = '', params = {}) => {
  const timestamp = new Date().getTime();
  const sign = createSign({
    appid,
    appkey,
    timestamp,
    ...params
  });
  return {
    params: qs.stringify(params, { indices: false }),
    url: `${url}?${qs.stringify({
      appid,
      timestamp,
      signature: sign,
    })}`
  }
}

// 导出get请求
export const get = (url, params) => {
  let si = signComputerConfig(params);

  let paramsStr = "";
  for (let i in params) {
    // @ts-ignore
    paramsStr += `&${i}=${params[i]}`;
  }
  const link = `${url}?appid=1&timestamp=${si.timestamp}&signature=${si.sign}${paramsStr}`;
  return axiosInstance.get(link);
}

// 导出post请求
export const post = (url, params) => {
  let si = signComputer(params);
  const link = `${url}?appid=1&userid=${si.userid}&timestamp=${si.timestamp}&signature=${si.sign}`;
  return axiosInstance.post(link, params);
}

const signComputer = (params) => {
  const timestamp = new Date().getTime();
  let user = window.localStorage.getItem("user");
  let userid = null;
  let token = '';
  if (user) {
    userid = JSON.parse(user).id;
    token = JSON.parse(user).secret;
  }
  let item = {
    appid,
    userid,
    timestamp,
    token,
    ...params
  }
  const sign = createSign(item);
  return {
    appid,
    userid,
    timestamp,
    sign,
    ...params
  }
};

// 未登录使用
const signComputerConfig = (params) => {
  const timestamp = new Date().getTime();
  let item = {
    appid,
    appkey: appkey,
    timestamp,
    ...params
  }
  const sign = createSign(item);
  return {
    appid,
    timestamp,
    sign,
    ...params
  }
};

// post请求, 参数Form Query
export const postForm = (url, params, param) => {
  debugger
  let si = signComputerForm(params, param);
  const link = `${url}?${qs.stringify({
    appid,
    userid: si.userid,
    timestamp: si.timestamp,
    signature: si.sign,
    ...param
  })}`
  return axiosInstance.post(link, params);
}

const signComputerForm = (params, param) => {
  const timestamp = new Date().getTime();
  let user = window.localStorage.getItem("user");
  let userid = null;
  let token = '';
  if (user) {
    userid = JSON.parse(user).id;
    token = JSON.parse(user).secret;
  }
  let item = {
    appid,
    userid,
    timestamp,
    token,
    ...params,
    ...param
  }
  const sign = createSign(item);
  return {
    appid,
    userid,
    timestamp,
    sign,
    ...params,
    ...param
  }
};

export default axiosInstance;




// WEBPACK FOOTER //
// ./src/utils/axios.js